import { Flex, GridItem, Text } from "@chakra-ui/react";

interface Props {
  title: string;
  value: string | boolean | null;
}

export const SiblingFieldItem = ({ title, value }: Props) => {
  return (
    <GridItem>
      <Flex flexDir="column" divideY="1px" gap="5px">
        <Text className="person-title-label">{title}</Text>
        <Text className="person-value-label" paddingTop="5px">
          {value ?? "-"}
        </Text>
      </Flex>
    </GridItem>
  );
};
